import React, { FunctionComponent } from 'react';
import { Dialog, Button } from 'shamrock-clover-ui';
import modalStyles from './modal.scss';
import { useTranslation } from 'react-i18next';

const Config = require('Config');

interface DeviceLimitProps {
  isOpen: boolean;
  cloneToken: string;
  closeModal: () => void;
  sendAnalyticsEvent: (arg: string) => void;
}
const DeviceLimitModal: FunctionComponent<DeviceLimitProps> = ({
  isOpen = false,
  cloneToken,
  closeModal,
  sendAnalyticsEvent,
}) => {
  const handleCancel = () => {
    sendAnalyticsEvent('no - create account');
    closeModal();
  };

  const handleCreateAccount = () => {
    sendAnalyticsEvent('yes - create account');
    window.location.href = `${Config.registerUrl}/?cloneToken=${encodeURIComponent(cloneToken)}`;
  };
  const { t } = useTranslation();

  return (
    <div className="largeBox">
      <Dialog
        open={isOpen}
        content={<div>{t('to_use_rtspro_please_log_out_on_another_device_or_create_a_new_account')}</div>}
        title={t('this_account_has_reached_its_device_limit')}
        closeOnBackdropClick={true}
        actions={
          <div className={modalStyles.actionContainer}>
            <Button buttonStyle="outlined" onClick={() => handleCancel()}>
              Close
            </Button>
            <Button onClick={() => handleCreateAccount()}>{t('create_acct')}</Button>
          </div>
        }
      />
    </div>
  );
};

export default DeviceLimitModal;
